// Shared styles for ResumeTab components

export const inputStyles = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '6px',
        fontSize: '0.875rem',
        '& fieldset': {
            borderColor: '#d1d5db',
        },
        '&:hover fieldset': {
            borderColor: '#d1d5db',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#4f46e5',
            borderWidth: '2px',
        },
    },
    '& .MuiInputBase-input': {
        padding: '8px 12px',
        fontSize: '0.875rem',
    },
    '& .MuiInputLabel-root': {
        fontSize: '0.875rem',
    },
};

// Error styles for mandatory empty fields - light red highlight
export const errorInputStyles = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '6px',
        fontSize: '0.875rem',
        backgroundColor: '#fef2f2',
        '& fieldset': {
            borderColor: '#fca5a5',
            borderWidth: '1.5px',
        },
        '&:hover fieldset': {
            borderColor: '#f87171',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#ef4444',
            borderWidth: '2px',
        },
    },
    '& .MuiInputBase-input': {
        padding: '8px 12px',
        fontSize: '0.875rem',
    },
    '& .MuiInputLabel-root': {
        fontSize: '0.875rem',
        color: '#dc2626',
    },
};

// Helper function to get input styles based on validation state
export const getInputStyles = (showErrors, isEmpty) => 
    showErrors && isEmpty ? errorInputStyles : inputStyles;

// Section header styles
export const sectionHeaderStyles = {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: '#111827',
    mb: 3,
};

// Label styles
export const labelStyles = {
    mb: 0.5,
    fontWeight: 500,
    color: '#111827',
    fontSize: '0.875rem',
};

// Required asterisk component
export const RequiredAsterisk = () => (
    <span style={{ color: '#4f46e5', marginLeft: '2px' }}>*</span>
);
